import React from 'react'
import LottiePlayer from "lottie-react";
import noleaderboard from '../../../assets/animationicons/leaderboard.json';

const NoLeaderboard = () => {
    return (
        <>
            <div className="noleadeerboard text-center">
                <LottiePlayer
                    animationData={noleaderboard}
                    style={{ height: 200 }}
                    autoplay
                    loop
                />
                <h5 className='mt-3'>No Leaderboard Found </h5>
            </div>
        </>
    )
}

export default NoLeaderboard
